import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Zoom } from "swiper/modules";
import "swiper/css";
import "swiper/css/zoom";

export default class Gallery {
  $html;
  _swiper;
  sources;
  constructor(sources, initialSlide = 0) {
    this.sources = sources;
    this.$html = $(this.HTML());
    this.$html.find(".gal__close").click(this.close.bind(this));
    this._swiper = new Swiper(this.$html.find(".swiper")[0], {
      modules: [Navigation, Zoom],
      slidesPerView: 1,
      loop: true,
      zoom: true,
      initialSlide,
      navigation: {
        nextEl: this.$html.find(".gal__nav--next")[0],
        prevEl: this.$html.find(".gal__nav--prev")[0],
      },
      on: {
        slideChange(swiper) {
          if (!swiper.slides[swiper.previousRealIndex]) return;
          const prev = swiper.slides[swiper.previousRealIndex];
          const video = prev.querySelector("video");
          if (video) {
            video.pause();
            video.currentTime = 0;
            if (document.pictureInPictureElement && document.pictureInPictureElement === video) {
              document.exitPictureInPicture();
            }
          }
        },
      },
    });
    this._swiper.on("zoomChange", (_, scale) => {
      if (scale > 1) {
        this._swiper.allowSlideNext = false;
        this._swiper.allowSlidePrev = false;
      } else {
        this._swiper.allowSlideNext = true;
        this._swiper.allowSlidePrev = true;
      }
    });
    this.open();
  }
  open() {
    $("body").append(this.$html);
  }
  close() {
    this.$html.remove();
  }
  HTML() {
    return `
      <div class="gal">
        <div class="gal__inner">
          ${this.SwiperHTML()}
        </div>
        <div class="gal__close">
          <svg class="d-flex" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path class="d-flex" fill-rule="evenodd" clip-rule="evenodd"
                              d="M31 29.684 29.684 31 15.52 16.797 1.316 31 0 29.684l14.204-14.203L0 1.316 1.316 0l14.203 14.165L29.684 0 31 1.316 16.835 15.48 31 29.684Z"
                              fill="#00205C" />
           </svg>
        </div>
      </div>
    `;
  }

  SwiperHTML() {
    return `
      <div class="swiper">
        <div class="swiper-wrapper">
          ${this.sources.reduce((acc, source) => {
            acc += `<div class="swiper-slide">`;
            acc += `<div class="swiper-zoom-container">`;
            acc += `<img loading="lazy" src="${source.url}" />`;
            acc += `</div>`;
            acc += `</div>`;
            return acc;
          }, "")}
        </div>
      </div>
      <div class="gal__nav gal__nav--next">
      <svg width="51" height="16" viewBox="0 0 51 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50.7071 8.7071C51.0976 8.31658 51.0976 7.68341 50.7071 7.29289L44.3431 0.928928C43.9526 0.538404 43.3195 0.538404 42.9289 0.928928C42.5384 1.31945 42.5384 1.95262 42.9289 2.34314L48.5858 8L42.9289 13.6569C42.5384 14.0474 42.5384 14.6805 42.9289 15.0711C43.3195 15.4616 43.9526 15.4616 44.3431 15.0711L50.7071 8.7071ZM8.74228e-08 9L50 9L50 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#00205C"></path>
</svg>
      </div>
        <div class="gal__nav gal__nav--prev">
<svg width="51" height="16" viewBox="0 0 51 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50.7071 8.7071C51.0976 8.31658 51.0976 7.68341 50.7071 7.29289L44.3431 0.928928C43.9526 0.538404 43.3195 0.538404 42.9289 0.928928C42.5384 1.31945 42.5384 1.95262 42.9289 2.34314L48.5858 8L42.9289 13.6569C42.5384 14.0474 42.5384 14.6805 42.9289 15.0711C43.3195 15.4616 43.9526 15.4616 44.3431 15.0711L50.7071 8.7071ZM8.74228e-08 9L50 9L50 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#00205C"></path>
</svg>
        </div>
    `;
  }
}

const images = [];
$(".gallery__collection-item-image").click(function () {
  if (!images.length) {
    $(".gallery__collection-item").map(function () {
      images.push({
        url: $(this).find("img").attr("src"),
        type: "image",
      });
    });
  }

  const $this = $(this);
  let initialSlide = $this.closest(".gallery__collection-item").index();
  let sources = images;

  $(`.gallery__collection-item`).each(function (index) {
    if ($(this)[0] === $this.closest(".gallery__collection-item")[0]) {
      initialSlide = index;
      return false;
    }
  });
  new Gallery(sources, initialSlide);
});

$(document).on("click", ".gal", function (e) {
  if (!$(e.target).closest(".swiper-slide").length) {
    $(this).fadeOut();
  }
});

$(document).on("click", ".gal__nav", function (e) {
  e.stopPropagation();
});
